/* Yeti: sticky mobile ATC — shows after main ATC button scrolls out of viewport */
(function(){
  if (window.__yetiStickyAtc) return;
  window.__yetiStickyAtc = true;

  function init() {
    var bar = document.getElementById('yeti-sticky-atc');
    var mainBtn = document.querySelector('[id^="ylv2-atc-"]');
    if (!bar || !mainBtn) return;

    document.body.classList.add('yeti-sticky-atc-on');

    // IntersectionObserver: hide sticky when main ATC is visible
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          bar.classList.remove('visible');
        } else {
          // Only show after user has scrolled PAST the main ATC (not before)
          if (window.scrollY > (mainBtn.getBoundingClientRect().top + window.scrollY - 200)) {
            bar.classList.add('visible');
          }
        }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
    observer.observe(mainBtn);

    // Sticky button click → trigger the main ATC click to preserve variant logic
    var stickyBtn = document.getElementById('yeti-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e){
        e.preventDefault();
        mainBtn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
